// ======================================================================
// File Name       : ContentDrillRegister.js
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import $ from 'jquery';
import React, { Component } from 'react';
import { Button, Col, Form } from 'react-bootstrap';
import { connect } from 'react-redux';
import { getDrillQuestionListForSort } from '../../actions/ContentAction';
import { saveActiveTabMenu } from '../../actions/TabMenuAction';
import * as ContentAction from '../../actions/content/ContentAction';
import * as ContentQuestionAction from '../../actions/content/ContentQuestionAction';
import Header from '../../components/Header';
import CustomLink from '../../components/button/CustomLink';
import ContentDrillQuestionSortDiaLog from '../../components/content/ContentDrillQuestionSortDialog';
import ContentRegister from '../../components/content/ContentDrillRegister';
import AddQuestionDialog from '../../components/content/ContentDrillRegisterAddQuestion';
import ContentRegisterAdvance from '../../components/content/ContentDrillRegisterAdvance';
import ConfirmDialog from '../../components/content/ContentDrillRegisterConfirmDialog';
import * as ContentConstant from '../../constants/ContentConstant';
import { DRILL_TYPE_ID } from '../../constants/ContentConstant';
import * as Path from '../../constants/PathConstants';
import { CONTENT_DRILL_LIST, PREVIEW_EACH_QUESTION_ATTRIBUTE } from '../../constants/PathConstants';
import * as Constant from '../../constants/index';

class ContentDrillRegister extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...props.content.register,
      showContentDrillQuestionSortDiaLog: false,// STEP9.0.0
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.deleteQuestion = this.deleteQuestion.bind(this);
    this.openAddQuestionDialog = this.openAddQuestionDialog.bind(this);
    this.dialogCancel = this.dialogCancel.bind(this);
    this.handleOpenOrCloseAdvanceSettings = this.handleOpenOrCloseAdvanceSettings.bind(this);
    this.fileChange = this.fileChange.bind(this);
    this.confirmDialogOK = this.confirmDialogOK.bind(this);
    this.onRegisterBtnClick = this.onRegisterBtnClick.bind(this);
    this.getConfirmData = this.getConfirmData.bind(this);
    this.validation = this.validation.bind(this);

    // dialog add question to drill
    this.handleDialogChange = this.handleDialogChange.bind(this);
    this.getStartEndDialogData = this.getStartEndDialogData.bind(this);
    this.handleDialogSortState = this.handleDialogSortState.bind(this);
    this.handleDialogCheckBox = this.handleDialogCheckBox.bind(this);
    this.dialogSearch = this.dialogSearch.bind(this);
    this.addQuestionDialogOK = this.addQuestionDialogOK.bind(this);
    this.dialogQuestionCancel = this.dialogQuestionCancel.bind(this);
    this.dismissMessage = this.dismissMessage.bind(this);
    this.handleCheckAll = this.handleCheckAll.bind(this);

    this.openPreviewEachQuestionAttribute = this.openPreviewEachQuestionAttribute.bind(this);
    this.handleChangeOption = this.handleChangeOption.bind(this);
    this.openOrCloseAttributeArea = this.openOrCloseAttributeArea.bind(this);
    this.handleChangeTextAttribute = this.handleChangeTextAttribute.bind(this);
    this.addAttribute = this.addAttribute.bind(this);
    this.removeAttributeSearch = this.removeAttributeSearch.bind(this);
    this.handleDialogSearch = this.handleDialogSearch.bind(this);
    this.removeAllQuestionFromList = this.removeAllQuestionFromList.bind(this);
    this.removeGroup = this.removeGroup.bind(this);
    this.addGroup = this.addGroup.bind(this);
    this.saveActiveTabMenu = this.saveActiveTabMenu.bind(this);
    // STEP9.0.0 START
    this.openSortDrillQuestionDialog = this.openSortDrillQuestionDialog.bind(this);
    this.dialogDrillQuestionSortCancel = this.dialogDrillQuestionSortCancel.bind(this);
    // STEP9.0.0 END
  }

  componentWillReceiveProps(nextProps) {
    const { content, questionListInfo } = nextProps;
    const { register, questionAddDialog, questionAddDialogArr } = content;
    const { questionId } = register;
    const { oldQuestionId } = register;
    const { fileName } = register;
    const { file } = register;
    const { skinSetData } = register;
    const { skinSet } = register;
    const { skinSetName } = register;
    const { registerSuccessfull } = register;

    if (questionId !== undefined) {
      this.setState({ questionId });
    }
    if (oldQuestionId !== undefined) {
      this.setState({ oldQuestionId });
    }
    if (fileName !== undefined && file !== undefined && file !== null) {
      this.setState({ fileName, file });
    }
    if (skinSetData !== undefined) {
      this.setState({ skinSetData });
    }
    if (registerSuccessfull) {
      this.setState({ registerSuccessfull });
    }
    if (questionAddDialogArr) {
      this.setState({ questionAddDialogArr });
    }
    //  --- question dialog
    const { questionDataList, dialogQuestionInfo, questionDataListTemp } = questionAddDialog;

    if (dialogQuestionInfo !== undefined) {
      dialogQuestionInfo.dataAffiliationType = ContentConstant.DATA_AFFIILIATION_TYPE.INTERNAL;
      this.setState({ dialogQuestionInfo });
    }

    const { drillGroupId } = this.state;
    let questionDataListTmp = questionDataListTemp;
    if (questionAddDialogArr !== undefined
      && questionAddDialogArr.allDrillGroupIds
      && questionAddDialogArr.allDrillGroupIds.length > 0
      && drillGroupId !== undefined) {
      questionDataListTmp = questionAddDialogArr.byDrillGroupId[drillGroupId];
    }
    this.setState({ questionDataList: questionDataListTmp });
    this.setState({ questionDataListTemp });
    if (questionListInfo !== undefined) {
      questionListInfo.questionList && questionListInfo.questionList.forEach((question) => {
        question.isChecked = false;
      }, this);
      this.setState({ questionListInfo });
    }
  }

  handleChangeOption(event) {
    const name = event.target.name;
    const value = event.target.value;
    const nameOptions = name.split('.').pop();
    const attributeOptions = { ...this.state.attributeOptions, ...{ [nameOptions]: value } };
    let attributeText = { ...this.state.attributeText };
    if (!attributeOptions[nameOptions]) {
      attributeText = { ...this.state.attributeText, ...{ [nameOptions]: '' } };
    }
    this.setState({ attributeOptions, attributeText });
  }

  handleChangeTextAttribute(event) {
    const name = event.target.name;
    const value = event.target.value;
    const attributeText = { ...this.state.attributeText, ...{ [name]: value } };
    this.setState({ attributeText });
  }

  addAttribute() {
    let number = this.state.number;
    number++;
    this.setState({
      ...this.state,
      number,
    });
  }

  componentWillMount() {
    this.getSkinSetList();
    const cachedIframe = $('.cached_question_skin');
    if (!(cachedIframe && cachedIframe.length)) {
      ContentQuestionAction.cachePreviewQuestionSkin();
    }
  }

  componentWillUnmount() {
    const INIT_DATA_REGISTER = {
      questionDataList: [],
      drillType: 0,
      drillId: '',
      drillName: '',
      continuedFrStart: false,
      collectingLastMistakenIssue: false,
      collectingLastMistakenIssueEvenOnce: false,
      collectionQuestionsRegisteredInFavorites: false,
      restrictReanswer: false,
      reanswerTime: '',
      scoringMethod: 0,
      skinSetData: {
        skinSet: '',
        skinSetName: '',
        skinSetList: [],
      },
      questionId: '',
      oldQuestionId: '',
      showAddQuestionModal: false,
      advanceButtonText: 'plus',
      timeLimit: ContentConstant.CONTENT_DRILL_OBJECT.DO_NOT_USE,
      drillTimeLimit: '',
      acquisition: 0,
      countingMethod: 1, // step6.3
      fullMark: 0,
      scoringRule: 0,
      useJudgment: false,
      partialPoint: '',
      useNote: false,
      useHTML: false,
      fileName: '',
      remark: '',
      showConfirmModal: false,
      registerSuccessfull: false,
      isAdvanceClosed: true,
      isAllowShowSearchMessage: false,
      adaptiveDrillDecisionQuestionNumber: 1,
      adaptiveDrillMaxQuestionNumber: '',
      attributeOptions: {},
      attributeText: {},
      isClosed: true,
      buttonText: 'plus',
      number: Constant.NUM_ATTRIBUTE_QUESTION_SEARCH,
    };
    this.props.dispatch(ContentAction.resetContentDrillRegisterData(INIT_DATA_REGISTER));
    this.props.dispatch(ContentAction.resetDialogQuestion());
    this.props.dispatch(ContentAction.removeQuestionListDrill());
  }

  handleInputChange(event) {
    const { name, value, checked, drillGroupId } = event.target;
    if (
      name === 'continuedFrStart' ||
      name === 'collectingLastMistakenIssue' ||
      name === 'collectingLastMistakenIssueEvenOnce' ||
      name === 'collectionQuestionsRegisteredInFavorites' ||
      name === 'restrictReanswer' ||
      name === 'useNote' ||
      name === 'useHTML' ||
      name === 'useJudgment'
    ) {
      if (name === 'useJudgment' && checked === false) {
        this.setState({
          ...this.state,
          ...{ [name]: checked },
          ...{ partialPoint: '' },
        });
      } else if (name === 'useNote' && checked === false) {
        this.setState({
          ...this.state,
          ...{ [name]: checked },
          ...{ useHTML: false },
          ...{ remark: '' },
          ...{ fileName: '' },
        });
      } else {
        const state = { ...this.state, ...{ [name]: checked } };
        this.setState(state);
      }
    } else if (name === 'notUseHTML') {
      this.setState({ useHTML: false });
    } else if (name === 'timeLimitNotUsed') {
      this.setState({
        ...this.state,
        ...{ timeLimit: ContentConstant.CONTENT_DRILL_OBJECT.DO_NOT_USE },
        ...{ drillTimeLimit: '', acquisition: 0, countingMethod: 1 }, // step6.3
      });
    } else if (name === 'timeLimitDrill') {
      this.setState({
        ...this.state,
        ...{ timeLimit: ContentConstant.CONTENT_DRILL_OBJECT.DRILL_PRIORITY },
      });
    } else if (name === 'timeLimitQuestion') {
      this.setState({
        ...this.state,
        ...{ timeLimit: ContentConstant.CONTENT_DRILL_OBJECT.QUESTION_PRIORITY },
        ...{ drillTimeLimit: '' },
      });
    } else if (name === 'skinSet') {
      const skinSetValue = value;
      const index = this.state.skinSetData.skinSetList.find(
        item => item.skinSetSecernId === skinSetValue,
      );
      const skinSetNameValue = index.skinSetName;
      const { skinSetData } = this.state;
      skinSetData.skinSet = skinSetValue;
      skinSetData.skinSetName = skinSetNameValue;
      this.setState({ ...this.state, ...{ skinSetData } });
    } else if (name === 'groupPoint') {
      const groupPoint = value;
      const { questionAddDialogArr } = this.state;
      if (questionAddDialogArr.allDrillGroupIds && questionAddDialogArr.allDrillGroupIds.indexOf(drillGroupId) < 0) {
        questionAddDialogArr.allDrillGroupIds.push(drillGroupId);
      }
      questionAddDialogArr.byDrillGroupPoint[drillGroupId] = groupPoint;
      this.setState({ ...this.state, ...{ questionAddDialogArr } });
    }
    // STEP10.0.0 START
    else if (name === `questionSelectMethod${drillGroupId}` && checked === true) {
      const { questionAddDialogArr } = this.state;
      const questionSelectMethod = parseInt(value, 10);
      if (questionAddDialogArr.allDrillGroupIds && questionAddDialogArr.allDrillGroupIds.indexOf(drillGroupId) < 0) {
        questionAddDialogArr.allDrillGroupIds.push(drillGroupId);
      }
      if (questionSelectMethod === ContentConstant.QUESTION_SELECT_METHOD.SPECIFIED_ORDER) {
        questionAddDialogArr.questionCount[drillGroupId] = '';
      }
      questionAddDialogArr.questionSelectMethod[drillGroupId] = questionSelectMethod;
      this.setState({ ...this.state, ...{ questionAddDialogArr } });
    }
    else if (name === `questionCount${drillGroupId}`) {
      const { questionAddDialogArr } = this.state;
      const questionCount = parseInt(value, 10);
      if (questionAddDialogArr.allDrillGroupIds && questionAddDialogArr.allDrillGroupIds.indexOf(drillGroupId) < 0) {
        questionAddDialogArr.allDrillGroupIds.push(drillGroupId);
      }
      questionAddDialogArr.questionCount[drillGroupId] = questionCount;
      this.setState({ ...this.state, ...{ questionAddDialogArr } });
    }
    // STEP10.0.0 END
    else {
      this.setState({ ...this.state, ...{ [name]: value } });
    }
  }

  openPreviewEachQuestionAttribute() {
    const newWindows = window.open(PREVIEW_EACH_QUESTION_ATTRIBUTE, Constant.PREVIEW_EACH_QUESTION_ATTRIBUTE_NAME, 'height=750,width=850');
    newWindows.focus();
  }

  getSkinSetList() {
    this.props.dispatch(ContentAction.registerContentDrillGetSkinSet());
  }
  openAddQuestionDialog(id) {
    const { register } = this.props;
    this.setState(
      {
        attributeOptions: register.attributeOptions,
        attributeText: register.attributeText,
        isClosed: true,
        buttonText: 'plus',
        number: Constant.NUM_ATTRIBUTE_QUESTION_SEARCH,
        showAddQuestionModal: true,
        drillGroupId: id,
      },
      () => {
        this.dialogSearch();
      },
    );
    this.props.dispatch(ContentQuestionAction.getAttributeQuestionList());
    this.props.dispatch(ContentAction.createValueAttributeItemDrill());
  }
  deleteQuestion(drillGroupId, questionId) {
    this.props.dispatch(ContentAction.registerContentDrillDeleteQuestion(drillGroupId, questionId));
  }

  handleOpenOrCloseAdvanceSettings() {
    this.setState({
      isAdvanceClosed: !this.state.isAdvanceClosed,
      advanceButtonText: this.state.isAdvanceClosed ? 'minute' : 'plus',
    });
  }
  fileChange(event) {
    if (event.target.files && event.target.files.length !== 0) {
      const file = event.target.files[0];
      this.props.dispatch(ContentAction.registerContentDrillAddFile(file));
    }
  }
  confirmDialogOK() {
    const params = this.getConfirmData(true);
    delete params.drillInfo.skinSetName;
    this.props.dispatch(ContentAction.registerContentDrillData(params));
    this.setState({ showAddQuestionModal: false, showConfirmModal: false });
  }
  dialogCancel() {
    this.setState({ showAddQuestionModal: false, showConfirmModal: false });
  }

  onRegisterBtnClick() {
    if (this.validation()) {
      this.setState({ showConfirmModal: true });
    }
  }
  getConfirmData() {
    const auth = this.props.auth;
    const state = this.state;
    const startConditionData = [];
    startConditionData.push(0);// default
    const questionScope = '0_';
    if (state.continuedFrStart) {
      startConditionData.push(1);
    }
    if (state.collectingLastMistakenIssue) {
      startConditionData.push(2);
    }
    if (state.collectingLastMistakenIssueEvenOnce) {
      startConditionData.push(3);
    }
    if (state.collectionQuestionsRegisteredInFavorites) {
      startConditionData.push(4);
    }
    const drillGroupArrayTemp = [];
    const { questionAddDialogArr } = this.state;
    if (questionAddDialogArr && questionAddDialogArr.allDrillGroupIds && questionAddDialogArr.allDrillGroupIds.length > 0) {
      questionAddDialogArr.allDrillGroupIds.map((drillGroupId, index) => {
        const drillGroupObject = {
          drillGroupId,
          drillQuestionIdScope: questionAddDialogArr.byDrillGroupId[drillGroupId] ? `${questionScope}${questionAddDialogArr.byDrillGroupId[drillGroupId].join('/')}` : '',
        };
        const groupPoint = questionAddDialogArr.byDrillGroupPoint[drillGroupId];
        groupPoint && parseInt(this.state.scoringRule, 10) === 3 && (drillGroupObject.groupPoint = parseInt(groupPoint, 10));
        //STEP10.0.0 START
        const questionSelectMethod = questionAddDialogArr.questionSelectMethod[drillGroupId] ? questionAddDialogArr.questionSelectMethod[drillGroupId] : ContentConstant.QUESTION_SELECT_METHOD.SPECIFIED_ORDER;
        drillGroupObject.questionSelectMethod = parseInt(questionSelectMethod, 10);
        if (questionSelectMethod === ContentConstant.QUESTION_SELECT_METHOD.RANDOM) {
          let questionCount = questionAddDialogArr.questionCount[drillGroupId];
          drillGroupObject.questionCount = parseInt(questionCount, 10);
        }
        //STEP10.0.0 END
        drillGroupArrayTemp.push(drillGroupObject);
      });
    }
    const scoringRule = isNaN(state.scoringRule) ? null : parseInt(state.scoringRule, 10);
    const useNote = state.useNote ? 1 : 0;
    const useHTML = useNote && state.useHTML ? 1 : 0;
    const data = {
      drillSecernId: state.drillId || null,
      drillTitle: state.drillName,
      startConditionList: startConditionData,
      drillKind: parseInt(state.drillType, 10),
      againLimit:
      state.restrictReanswer && state.reanswerTime !== '' ? `1_${state.reanswerTime}` : '0',
      scoreForm: parseInt(state.scoringMethod, 10),
      limitTimeAdaptedTarget: !isNaN(state.timeLimit) ? parseInt(state.timeLimit, 10) : 0,
      drillLimitTime: isNaN(state.drillTimeLimit) ? null : parseInt(state.drillTimeLimit, 10),
      limitTimeOverAction: isNaN(state.acquisition) ? 0 : parseInt(state.acquisition, 10),
      limitTimeCountForm: isNaN(state.countingMethod) ? 1 : parseInt(state.countingMethod, 10), // step6.3
      perfectPoint: scoringRule !== null && (scoringRule === 1 || scoringRule === 2) ?
      parseInt(state.fullMark, 10) : null,
      sankakuJudgeUseSet: parseInt(state.drillType, 10) != ContentConstant.DRILL_TYPE_ID.ADAPTIVE ? (state.useJudgment && state.partialPoint !== '' ? 1 : 0) : null,
      sankakuMarkSet: parseInt(state.drillType, 10) != ContentConstant.DRILL_TYPE_ID.ADAPTIVE && state.useJudgment ? parseInt(state.partialPoint, 10) : null,
      attentionRelateSet: useNote,
      attentionHtmlUse: useHTML,
      attentionContent: !useHTML ? state.remark : null,
      markRule: scoringRule,
      skinSetSecernId: state.skinSetData.skinSet,
      skinSetName: state.skinSetData.skinSetName,
      drillGroupArray: parseInt(state.drillType, 10) != ContentConstant.DRILL_TYPE_ID.ADAPTIVE ? drillGroupArrayTemp : [], // #7181
      adaptiveDrillDecisionQuestionNumber: parseInt(state.drillType, 10) == ContentConstant.DRILL_TYPE_ID.ADAPTIVE && state.adaptiveDrillDecisionQuestionNumber > 0 ? parseInt(state.adaptiveDrillDecisionQuestionNumber, 10) : null,
      adaptiveDrillMaxQuestionNumber: parseInt(state.drillType, 10) == ContentConstant.DRILL_TYPE_ID.ADAPTIVE && state.adaptiveDrillMaxQuestionNumber > 0 ? parseInt(state.adaptiveDrillMaxQuestionNumber, 10) : null,
    };
    if (data.limitTimeAdaptedTarget === ContentConstant.CONTENT_DRILL_OBJECT.DO_NOT_USE) {
      data.limitTimeOverAction = 0;
      data.drillLimitTime = 0;
    }
    if (data.limitTimeAdaptedTarget === ContentConstant.CONTENT_DRILL_OBJECT.QUESTION_PRIORITY) {
      data.drillLimitTime = 0;
    }
    const params = {
      authCd: auth.authCd,
      drillInfo: data,
    };
    const attentionZipFile = state.file && useHTML ? state.file : null;
    if (attentionZipFile) {
      params.drillInfo.attentionZipFileName = state.fileName;
      params.attentionZipFile = attentionZipFile;
    }
    return params;
  }
  validation() {
    return Object.keys(this.refsToValidate).every(
      ref => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation(),
    );
  }

  // -------
  addQuestionDialogOK() {
    const { questionDataListTemp, drillGroupId } = this.state;
    this.props.dispatch(
      ContentAction.registerContentDrillAddQuestion(questionDataListTemp, drillGroupId),
    );
    this.setState({ showAddQuestionModal: false }, () => {
      let questionList = [];
      if (questionDataListTemp && questionDataListTemp.length) {
        questionList = questionDataListTemp;
      }
      this.props.dispatch(ContentAction.getQuestionListDrillDetail(questionList));
    });
  }

  handleDialogChange(event) {
    const { name, value } = event.target;
    const dialogQuestionInfo = { ...this.state.dialogQuestionInfo, ...{ [name]: value } };
    this.setState({ dialogQuestionInfo }, () => {
      this.props.dispatch(
        ContentAction.updateDialogSearchInfo(dialogQuestionInfo),
      );
    });
  }

  handleDialogCheckBox(id, event) {
    const { questionListInfo, questionDataListTemp } = this.state;
    for (const question of questionListInfo.questionList) {
      if (question.questionSecernId && question.questionSecernId === id) {
        question.isChecked = question.isChecked ? !question.isChecked : true;
        if (question.isChecked) {
          questionDataListTemp.push(id);
        } else {
          const index = questionDataListTemp.indexOf(id);
          if (index >= 0) {
            questionDataListTemp.splice(index, 1);
          }
        }
      }
    }
    this.setState({ questionListInfo });
  }

  handleCheckAll() {
    const { questionListInfo, questionDataListTemp } = this.state;
    const checkQuestionIdChecked = [];
    if (questionListInfo && questionListInfo.questionList && questionListInfo.questionList.length) {
      questionListInfo.questionList.map((question) => {
        const pos = questionDataListTemp.indexOf(question.questionSecernId);
        if (pos > -1) {
          checkQuestionIdChecked.push(pos);
        }
      });
      if (checkQuestionIdChecked.length === questionListInfo.questionList.length) {
        // uncheckAll
        questionListInfo.questionList.map((question) => {
          question.isChecked = false;
          const pos = questionDataListTemp.indexOf(question.questionSecernId);
          if (pos > -1) {
            questionDataListTemp.splice(pos, 1);
          }
          return null;
        });
        this.setState({ questionDataListTemp, questionListInfo });
        return;
      }
      // checkAll
      questionListInfo.questionList.map((question) => {
        question.isChecked = true;
        if (questionDataListTemp.indexOf(question.questionSecernId) < 0) {
          questionDataListTemp.unshift(question.questionSecernId);
        }
        return null;
      });
      this.setState({ questionDataListTemp, questionListInfo });
    }
  }

  dialogSearch(isSearch) {
    const dialogQuestionInfo = { ...this.state.dialogQuestionInfo };
    const questionAttributeId = this.state.attributeOptions;
    const eachQuestionAttributeName = this.state.attributeText;
    if (questionAttributeId || (questionAttributeId && eachQuestionAttributeName)) {
      const questionAttributeList = [];
      let attributeText = {};
      let attributeOptions = {};
      if (eachQuestionAttributeName) {
        attributeText = eachQuestionAttributeName;
      }
      if (questionAttributeId) {
        attributeOptions = questionAttributeId;
      }
      const attrArray = Object.keys(attributeOptions);
      attrArray.forEach((element) => {
        if (element && attributeOptions[element]) {
          const attrArrayObj = {
            questionAttributeId: attributeOptions[element],
            eachQuestionAttributeName: attributeText[element],
          };
          questionAttributeList.push(attrArrayObj);
        }
      });
      dialogQuestionInfo.questionAttributeList = questionAttributeList;
    }
    if (isSearch) {
      dialogQuestionInfo.startPosition = 0;
      dialogQuestionInfo.questionSortType = null;
      dialogQuestionInfo.ascendingDescendingSort = null;
    }
    this.setState({ isAllowShowSearchMessage: false },
      () => {
        this.props.dispatch(
          ContentAction.updateDialogSearchInfo(dialogQuestionInfo),
        );
        this.props.dispatch(
          ContentQuestionAction.searchContent(dialogQuestionInfo),
        ).then(() => {
          this.setState({ isAllowShowSearchMessage: true });
        });
      },
    );
  }

  handleDialogSearch() {
    const { dialogQuestionInfo } = this.state;
    dialogQuestionInfo.startPosition = 0;
    this.setState(
      {
        dialogQuestionInfo,
      },
      () => {
        this.dialogSearch();
      },
    );
  }

  dialogQuestionCancel() {
    this.props.dispatch(
      ContentAction.resetDialogQuestionSearchInfo(),
    );
    this.setState({
      showAddQuestionModal: false,
    });
  }

  openOrCloseAttributeArea() {
    this.setState({
      isClosed: !this.state.isClosed,
      buttonText: this.state.isClosed ? 'minute' : 'plus',
    });
  }

  handleDialogSortState(row) {
    const { dialogQuestionInfo } = this.state;
    dialogQuestionInfo.ascendingDescendingSort = row.sortState;
    dialogQuestionInfo.questionSortType = row.sortBy;
    this.setState(
      {
        dialogQuestionInfo,
      },
      () => {
        this.dialogSearch();
      },
    );
  }

  /**
 * Handle event when user change page on dialog paging
 * @param page
 */
  getStartEndDialogData(startPosition) {
    const { dialogQuestionInfo } = this.state;
    dialogQuestionInfo.startPosition = startPosition;
    this.setState(
      {
        dialogQuestionInfo,
      },
      () => {
        this.dialogSearch();
      },
    );
  }

  dismissMessage() {
    this.setState({ isAllowShowSearchMessage: false });
  }

  removeAttributeSearch(name) {
    let attributeText = {};
    let attributeOptions = {};
    if (this.state && this.state.attributeText) {
      attributeText = { ...this.state.attributeText };
    }
    if (this.state && this.state.attributeOptions) {
      attributeOptions = { ...this.state.attributeOptions };
    }
    const attrArray = Object.keys(attributeOptions);
    const nameOptions = name.split('.').pop();
    const attrIndex = attrArray.indexOf(nameOptions);
    let number = this.state.number;
    attrArray.forEach((element) => {
      const indexElement = attrArray.indexOf(element);
      if (attrIndex === indexElement) {
        for (let i = attrIndex; i < number; i++) {
          const posDelete = attrArray[i];
          const posNext = attrArray[i + 1];
          attributeOptions[posDelete] = attributeOptions[posNext];
          attributeText[posDelete] = attributeText[posNext];
          // Reset value of last item to empty
          const lastElement = attrArray[Constant.NUM_ATTRIBUTE_QUESTION_SEARCH_MAX - 1];
          if (i === Constant.NUM_ATTRIBUTE_QUESTION_SEARCH_MAX - 1) {
            attributeOptions[lastElement] = '';
            attributeText[lastElement] = '';
          }
        }
      }
    });
    number--;
    this.setState({
      ...this.state,
      number,
      attributeOptions,
      attributeText,
    });
  }

  removeAllQuestionFromList(drillGroupId) {
    this.props.dispatch(ContentAction.removeAllQuestionFromList(drillGroupId));
  }

  addGroup(drillGroupId) {
    this.props.dispatch(ContentAction.addGroup(drillGroupId));
  }

  removeGroup(drillGroupId) {
    this.props.dispatch(ContentAction.removeGroup(drillGroupId));
  }

  saveActiveTabMenu() {
    this.props.dispatch(saveActiveTabMenu(Path.CONTENT_QUESTION_LIST));
  }
  //STEP9.0.0 START
  openSortDrillQuestionDialog(groupIndex, drillGroupId) {
    this.setState({
      showContentDrillQuestionSortDiaLog: true,
    });
    const { dispatch } = this.props;
    dispatch(getDrillQuestionListForSort(groupIndex, drillGroupId));
  }

  dialogDrillQuestionSortCancel() {
    this.setState({
      showContentDrillQuestionSortDiaLog: false,
    });
  }
  //STEP9.0.0 END

  render() {
    const { questionDataList, registerSuccessfull, isAllowShowSearchMessage, drillGroupId, questionAddDialogArr } = this.state;
    const { authCd, institutionId } = this.props;
    const isAdaptiveDrill = parseInt(this.state.drillType, 10) == DRILL_TYPE_ID.ADAPTIVE;
    this.refsToValidate = [];
    if (registerSuccessfull) {
      this.props.history.push(CONTENT_DRILL_LIST);
    }
    const { questionDrillList, questionDrillListArr } = this.props.content;
    return (
      <Form className='form-horizontal'>
        <Col sm={12} className="margin-bottom-10 padding-left-clear">
          <CustomLink
            className="margin-right-7 url-list"
            to={Path.CONTENT_DRILL_LIST}
            text="ドリル一覧に戻る"
            icon="bi bi-chevron-left"
          />
          <Header name="ドリルの追加" />
          <Col>
            <ContentRegister
              handleChange={this.handleInputChange}
              handleDeleteQuestion={this.deleteQuestion}
              handleEditQuestion={this.openAddQuestionDialog}
              questionDataList={questionDataList}
              drillGroupId={drillGroupId}
              questionAddDialogArr={questionAddDialogArr}
              scoringRule={this.state.scoringRule}
              drillId={this.state.drillId}
              drillName={this.state.drillName}
              drillType={this.state.drillType}
              scoringMethod={this.state.scoringMethod}
              skinSet={this.state.skinSetData.skinSet}
              skinSetList={this.state.skinSetData.skinSetList}
              addQuestionBtn={this.openAddQuestionDialog}
              openSortDrillQuestionDialog={this.openSortDrillQuestionDialog} // STEP9.0.0 
              continuedFrStart={this.state.continuedFrStart}
              collectingLastMistakenIssue={this.state.collectingLastMistakenIssue}
              collectingLastMistakenIssueEvenOnce={this.state.collectingLastMistakenIssueEvenOnce}
              collectionQuestionsRegisteredInFavorites={
              this.state.collectionQuestionsRegisteredInFavorites
            }
              restrictReanswer={this.state.restrictReanswer}
              ref={(ref) => {
                if (ref) {
                  this.refsToValidate.push(ref);
                }
              }}
              adaptiveDrillMaxQuestionNumber={this.state.adaptiveDrillMaxQuestionNumber}
              adaptiveDrillDecisionQuestionNumber={this.state.adaptiveDrillDecisionQuestionNumber}
              questionDrillList={questionDrillList}
              questionDrillListArr={questionDrillListArr}
              removeAllQuestionFromList={this.removeAllQuestionFromList}
              removeGroup={this.removeGroup}
              addGroup={this.addGroup}
            />
            {!isAdaptiveDrill && <ContentRegisterAdvance
              handleChange={this.handleInputChange}
              openOrCloseAdvanceSettings={this.handleOpenOrCloseAdvanceSettings}
              buttonText={this.state.advanceButtonText}
              isClosed={this.state.isAdvanceClosed}
              timeLimit={this.state.timeLimit}
              acquisition={this.state.acquisition}
              countingMethod={this.state.countingMethod}
              scoringRule={this.state.scoringRule}
              useJudgment={this.state.useJudgment}
              partialPoint={this.state.partialPoint}
              drillTimeLimit={this.state.drillTimeLimit}
              fullMark={this.state.fullMark}
              useNote={this.state.useNote}
              useHTML={this.state.useHTML}
              handleFileChange={this.fileChange}
              fileName={this.state.fileName}
              remark={this.state.remark}
              attentionContent={this.state.attentionContent}
              attentionHtmlUse={this.state.attentionHtmlUse}
              ref={(ref) => {
                if (ref) {
                  this.refsToValidate.push(ref);
                }
              }}
            />
          }
          </Col>
          <Col sm={12} className="text-center margin-top-20 margin-bottom-10">
            <Button
              variant="primary"
              className="btn-96 text-center"
              onClick={this.onRegisterBtnClick}
            >
            OK
            </Button>
          </Col>
          <AddQuestionDialog
            showModal={this.state.showAddQuestionModal}
            handleChange={this.handleDialogChange}
            handleCheckbox={this.handleDialogCheckBox}
            handleDialogSearch={this.handleDialogSearch}
            dialogGetStartEndData={this.getStartEndDialogData}
            handleSearchSortState={this.handleDialogSortState}
            onDialogCancel={this.dialogQuestionCancel}
            onDialogOK={this.addQuestionDialogOK}
            startPosition={this.state.dialogQuestionInfo ?
            this.state.dialogQuestionInfo.startPosition : 0}
            recordNum={this.state.questionListInfo ? this.state.questionListInfo.recordNum : 0}
            existQuestionList={this.state.questionDataList}
            dialogSearchResult={this.state.questionListInfo}
            questionDataListTemp={this.state.questionDataListTemp}
            isEdit={false}
            {...this.state.dialogQuestionInfo}
            dismissMessage={this.dismissMessage}
            isAllowShowSearchMessage={isAllowShowSearchMessage}
            openPreviewEachQuestionAttribute={this.openPreviewEachQuestionAttribute}
            attributeListData={this.props.attributeListData}
            handleChangeOption={this.handleChangeOption}
            attributeOptions={this.state.attributeOptions}
            openOrCloseAttributeArea={this.openOrCloseAttributeArea}
            isClosed={this.state.isClosed}
            buttonText={this.state.buttonText}
            handleChangeTextAttribute={this.handleChangeTextAttribute}
            attributeText={this.state.attributeText}
            addAttribute={this.addAttribute}
            number={this.state.number}
            removeAttributeSearch={this.removeAttributeSearch}
            authCd={authCd}
            institutionId={institutionId}
            handleCheckAll={this.handleCheckAll}
            saveActiveTabMenu={this.saveActiveTabMenu}
          />
          {/* STEP 9.0.0 START */}
          <ContentDrillQuestionSortDiaLog
            showModal={this.state.showContentDrillQuestionSortDiaLog}
            onDialogCancel={this.dialogDrillQuestionSortCancel}
          />
          {/* STEP 9.0.0 END */}
          <ConfirmDialog
            onDialogOK={this.confirmDialogOK}
            onDialogCancel={this.dialogCancel}
            drillDetail={this.getConfirmData}
            showModal={this.state.showConfirmModal}
            questionDrillList={questionDrillList}
            questionDrillListArr={questionDrillListArr}
            markRule={this.state.scoringRule}
          />
        </Col>
      </Form>
    );
  }
}
const mapStateToProps = (state, ownProps) => {
  const { authedUser } = state.authed;
  const institutionId = (authedUser && authedUser.institutionId) ? authedUser.institutionId : '';
  const authCd = (authedUser && authedUser.authCd) ? authedUser.authCd : '';
  return {
    ...{ content: state.content,
      auth: state.authed.authedUser,
      questionListInfo: state.question ? state.question.questionListInfo : {},
      attributeListData: state.question ? state.question.attributeListData : {},
      register: state.content ? state.content.register : {},
    },
    authCd,
    institutionId,
  };
};

export default connect(mapStateToProps)(ContentDrillRegister);
